import { FloatingLabel, Form, Button, Alert } from "react-bootstrap";
import "./Auth.css";
import { useState } from "react";
import { useNavigate } from 'react-router-dom';
import axios from "axios";
import config from "../../config";
import toolLogo from "../../img/streamlined-tool-log.png"; // Adjust the path to your second logo
import csLogo from "../../img/CSHub-logo.png";

const SignUp = () => {
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [showErrors, setShowErrors] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const navigate = useNavigate();

    const handleNameChange = (e) => setName(e.target.value);
    const handleEmailChange = (e) => setEmail(e.target.value);
    const handlePasswordChange = (e) => setPassword(e.target.value);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setShowErrors(true);

        const trimmedName = name.trim();
        const trimmedEmail = email.trim();
        const trimmedPassword = password.trim();

        if (!trimmedName || !trimmedEmail || !trimmedPassword) {
            setErrorMessage("Please fill all the fields");
            return;
        }

        try {
            const response = await axios.post(`${config.apiUrl}/api/auth/register`, {
                username: trimmedName,
                email: trimmedEmail,
                password: trimmedPassword
            });

            localStorage.setItem('token', response.data.access_token);
            localStorage.setItem('user', JSON.stringify(response.data.user));
            localStorage.setItem("user_id", response.data.user_id);

            navigate('/dashboard');
        } catch (error) {
            if (error.response && error.response.data && error.response.data.error) {
                setErrorMessage(`Registration failed: ${error.response.data.error}`);
            } else {
                setErrorMessage("Registration failed: An unexpected error occurred.");
            }
            console.error(error);
        }
    };


    return (
        <div className="auth__box">
            <div className="signup__box--left">
                <img src={toolLogo} alt="Tool logo" id="signup__left--image" />
                <h1 className="signup__left--title">Welcome Back!</h1>
                <p className="signup__left--text">Please click the button below to sign in if you already have an account.</p>
                <Button className="signup__box--left--button" href="/signin">Sign In</Button>
                <p className="signup__left--bottomtext">
                    MIT CSHub | cshub@mit.edu
                </p>
            </div>
            <div className="signup__box--right">
                <img src={csLogo} alt="CSHub Logo" id="signup__right--image" />
                <h1 className="signup__right--title">Create Account</h1>
                <p className="signup__right--text">Please enter your info for registration.</p>
                <Form className="signup__right--form" noValidate onSubmit={handleSubmit}>
                    <FloatingLabel controlId="floatingInput" label="Username" className="mb-3">
                        <Form.Control
                            type="text"
                            value={name}
                            onChange={handleNameChange}
                            className="auth__input"
                            placeholder="Your Name"
                            name="name"
                            required
                            isInvalid={showErrors && !name}
                        />
                        <Form.Control.Feedback type="invalid">
                            Please provide a name.
                        </Form.Control.Feedback>
                    </FloatingLabel>

                    <FloatingLabel controlId="floatingEmail" label="Email" className="mb-3">
                        <Form.Control
                            type="email"
                            value={email}
                            onChange={handleEmailChange}
                            className="auth__input"
                            placeholder="name@example.com"
                            name="email"
                            required
                            isInvalid={showErrors && !email}
                        />
                        <Form.Control.Feedback type="invalid">
                            Please provide a valid email.
                        </Form.Control.Feedback>
                    </FloatingLabel>
                    <FloatingLabel controlId="floatingPassword" label="Password">
                        <Form.Control
                            type="password"
                            value={password}
                            onChange={handlePasswordChange}
                            className="auth__input"
                            placeholder="Password"
                            name="password"
                            required
                            isInvalid={showErrors && !password}
                        />
                        <Form.Control.Feedback type="invalid">
                            Please provide a password.
                        </Form.Control.Feedback>
                    </FloatingLabel>
                    {errorMessage && <Alert variant="danger">{errorMessage}</Alert>}
                    <Button className="signup__box--right--button" type="submit">Sign Up</Button>
                    <p className="signup__right--bottomtext">
                        2026 &copy; MIT.{" "}
                        <a href="https://accessibility.mit.edu/" target="_blank" rel="noopener noreferrer">
                            Learn about MIT's commitment to accessibility.
                        </a>
                    </p>
                </Form>
            </div>
        </div>
    )
};

export default SignUp;
